import React from 'react'
import PropTypes from 'prop-types'
import './AloCheckbox.scss'

let AloCheckbox = props => {
  return (
    <div className='AloCheckbox'>
      <label>
        <input
          type='radio'
          checked={props.active}
          value={props.value}
          onChange={() => props.handleChange(props.value)}
        />
        <div className='AloCheckbox__radioCheck' />
        {props.icon}
        {props.label || props.value}
      </label>
    </div>
  )
}

AloCheckbox.propTypes = {
  active: PropTypes.bool,
  handleChange: PropTypes.func,
  icon: PropTypes.node,
  value: PropTypes.string,
  label: PropTypes.string
}

export default AloCheckbox
